<div class="source-viewer-sidebar" [class.visible]="visible">
  <div class="sidebar-header">
    <div class="source-title">
      <mat-icon>description</mat-icon>
      <span>{{ totalSources }} sources</span>
    </div>
    <button mat-icon-button (click)="closeDialog()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="source-selector">
    <mat-form-field appearance="outline">
      <mat-label>Source</mat-label>
      <mat-select [(value)]="selectedSourceIndex" (selectionChange)="onSourceSelectionChange()">
        @for (source of data.sources; track source; let i = $index) {
          <mat-option [value]="i">
            {{ truncateSourceName(source.name) }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  @if (hasChunks) {
    <div class="embedding-badges">
      <div class="badges-header">
        <div class="badges-top-row">
          <span class="badges-label">
            Referenced Embeddings:
            <span class="badge-count">{{ currentSourceChunks.length }}</span>
          </span>
          @if (currentSourceChunks.length > 20) {
            <div class="pagination-controls">
              <button
                class="page-btn"
                [disabled]="currentBadgePage === 0"
                (click)="previousBadgePage()"
                [attr.aria-label]="'Previous page'"
                >
                ‹
              </button>
              <span class="page-info">{{ currentBadgePage + 1 }} / {{ totalBadgePages }}</span>
              <button
                class="page-btn"
                [disabled]="currentBadgePage >= totalBadgePages - 1"
                (click)="nextBadgePage()"
                [attr.aria-label]="'Next page'"
                >
                ›
              </button>
            </div>
          }
        </div>
        <div class="badge-container">
          @for (chunk of getVisibleBadges(); track chunk; let i = $index) {
            <button
              class="embedding-badge"
              [class.selected]="getBadgeGlobalIndex(i) === selectedChunkIndex"
              (click)="selectEmbeddingAndScroll(getBadgeGlobalIndex(i))"
              [attr.aria-label]="'Select embedding ' + (getBadgeGlobalIndex(i) + 1)"
              >
              {{ getBadgeGlobalIndex(i) + 1 }}
            </button>
          }
        </div>
      </div>
    </div>
  }

  @if (data.sources[selectedSourceIndex]; as currentSource) {
    <div class="source-content">
      <!-- Source Info Card -->
      <div class="source-info-card">
        <div class="source-header">
          <div class="source-details">
            <h4 class="source-name">{{ currentSource.name }}</h4>
            <div class="source-metadata">
              <!-- Folder Path -->
              @if (currentSource.folder?.length) {
                <div class="metadata-item">
                  <mat-icon class="metadata-icon">folder</mat-icon>
                  <span class="metadata-text">{{ currentSource.folder?.join(' / ') }}</span>
                </div>
              }
              <!-- File Link -->
              @if (currentSource.fileLink) {
                <div class="metadata-item">
                  <mat-icon class="metadata-icon">link</mat-icon>
                  <a [href]="currentSource.fileLink" target="_blank" class="metadata-link">
                    Open source file
                  </a>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <!-- Content Sections -->
      <div class="content-sections">
        <!-- Referenced Text (the cited embedding) -->
        @if (hasChunks && selectedChunkText && !isLoadingContent) {
          <div class="content-section referenced-text-section">
            <div class="section-header">
              <div class="section-title">
                <mat-icon>format_quote</mat-icon>
                <h4>Referenced Text</h4>
              </div>
              <span class="embedding-indicator">
                <mat-icon>highlight</mat-icon>
                Embedding {{ selectedChunkIndex + 1 }} of {{ currentSourceChunks.length }}
              </span>
            </div>
            <div class="source-text referenced-chunk">
              <p>{{ selectedChunkText }}</p>
            </div>
          </div>
        }
        <!-- Source Content with Highlighted Embedding -->
        <div class="content-section">
          <div class="section-header">
            <div class="section-title">
              <mat-icon>article</mat-icon>
              <h4>Full Source Content</h4>
            </div>
          </div>
          <div class="source-text" #sourceTextContainer>
            @if (isLoadingContent) {
              <div class="loading-container">
                <mat-progress-spinner
                  [diameter]="32"
                  mode="indeterminate"
                  color="accent"
                ></mat-progress-spinner>
                <span class="loading-text">Loading source content...</span>
              </div>
            } @else if (hasChunks) {
              <div [innerHTML]="getHighlightedContent()"></div>
            } @else {
              <p>{{ currentSource.fullPreview }}</p>
            }
          </div>
        </div>
        <!-- External References -->
        @if (currentSource.uiExternalRefsToDisplay?.length) {
          <div class="content-section">
            <div class="section-header">
              <div class="section-title">
                <mat-icon>open_in_new</mat-icon>
                <h4>External References</h4>
              </div>
            </div>
            <div class="external-refs">
              @for (ref of currentSource.uiExternalRefsToDisplay; track ref) {
                <div class="external-ref">
                  <mat-icon class="ref-icon">link</mat-icon>
                  <span class="ref-text">{{ ref }}</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
